import { render, staticRenderFns } from "./ClinicPage.vue?vue&type=template&id=12c8306c&scoped=true"
import script from "./ClinicPage.vue?vue&type=script&lang=js"
export * from "./ClinicPage.vue?vue&type=script&lang=js"
import style0 from "./ClinicPage.vue?vue&type=style&index=0&id=12c8306c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c8306c",
  null
  
)

export default component.exports